import { useCallback } from 'react';
import type { AutocompleteOption } from '../../types';

export const usePickupLocationResolver = (dispatch: (action: { type: string; payload?: unknown }) => void) => {
    const resolvePickupLocation = useCallback(
        (payload: AutocompleteOption | null) => {
            if (payload?.placeId && !Number.parseInt(payload?.code ?? '', 10)) {
                fetch(`https://www.finn.no/travel-api/places?id=${payload.placeId}`)
                    .then((response) => response.json())
                    .then((result) => {
                        dispatch({
                            type: 'CAR/SET_PICKUP_PARAMS',
                            payload: {
                                text: payload.text,
                                latitude: result?.place?.latitude,
                                longitude: result?.place?.longitude,
                            },
                        });
                    });
            } else {
                dispatch({
                    type: 'CAR/SET_PICKUP_PARAMS',
                    payload,
                });
            }
        },
        [dispatch],
    );

    return { resolvePickupLocation };
};
